import {
  CollectionActions,
  CollectionStateSlice,
  mergeDocuments,
  mergeWebsocketDocuments,
  PushSuccessAction,
  Reference,
  transformIntoDocuments,
  updateWebsocketDocuments,
} from '@freelancer/datastore/core';
import { ReviewsCollection } from '../reviews/reviews.types';
import {
  transformInvoice,
  transformWebSocketUpdatedInvoiceEvent,
} from './invoices.transformers';
import { InvoicesCollection } from './invoices.types';

export function invoicesReducer(
  state: CollectionStateSlice<InvoicesCollection> = {},
  action: CollectionActions<InvoicesCollection | ReviewsCollection>,
) {
  switch (action.type) {
    case 'API_FETCH_SUCCESS': {
      if (action.payload.type === 'invoices') {
        const { result, ref, order } = action.payload;
        return mergeDocuments<InvoicesCollection>(
          state,
          transformIntoDocuments(result.invoices, transformInvoice),
          order,
          ref,
        );
      }
      return state;
    }

    case 'WS_MESSAGE': {
      if (action.payload.parent_type === 'notifications') {
        const ref: Reference<InvoicesCollection> = {
          path: {
            collection: 'invoices',
            authUid: action.payload.toUserId,
          },
        };

        switch (action.payload.type) {
          case 'invoiceUpdated': {
            return mergeWebsocketDocuments(
              state,
              [transformWebSocketUpdatedInvoiceEvent(action.payload)],
              ref,
            );
          }

          default:
            return state;
        }
      }

      return state;
    }

    case 'API_PUSH_SUCCESS': {
      // After a successful POST to `/reviews` with a `reviewTypeApi.INVOICE`
      // then the `latestUnreviewedByEmployer` field of the invoice ID returned
      // will be flipped to false, as all of the invoices will have been
      // reviewed.
      if (action.payload.type === 'reviews') {
        const { payload } = action as PushSuccessAction<ReviewsCollection>;
        const { invoiceId } = payload.document.context;

        if (
          payload.document.reviewType === 'invoice' &&
          invoiceId !== undefined
        ) {
          const ref: Reference<InvoicesCollection> = {
            path: {
              collection: 'invoice',
              authUid: payload.ref.path.authUid,
            },
          };

          return updateWebsocketDocuments<InvoicesCollection>(
            state,
            [invoiceId],
            invoice => ({
              ...invoice,
              latestUnreviewedByEmployer: false,
            }),
            ref,
          );
        }
      }
      return state;
    }

    default:
      return state;
  }
}
